import React, { memo, useEffect, useState } from "react";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";

const PhoneNumber = ({ state, name, setState, readOnly = false }) => {
  // `value` sera le numéro de téléphone analysé au format E.164.
  // Exemple : "+12133734253".

  const [value, setValue] = useState();

  useEffect(() => {
    setState((elt) => {
      return {
        ...elt,
        [name]: value ? value : "",
      };
    });
  }, [value]);

  return (
    <PhoneInput
      placeholder=""
      international
      ountryCallingCodeEditable={false}
      value={value ? value : state ? state : undefined}
      onChange={setValue}
      readOnly={readOnly}
      autoComplete={false}
    />
  );
};

export default memo(PhoneNumber);
